import { DialogActions } from '@mui/material'
import React from 'react'
import { CustomButtonContained, CustomButtonOutline } from '../../utils/CustomButton'

const DialogFooter = ({ handleClose, buttonName }) => {
    return (
        <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
            <CustomButtonOutline buttonText="Cancel" onClick={handleClose} />
            <CustomButtonContained buttonText={buttonName} isSubmit={true} />
        </DialogActions>
    )
}

export default DialogFooter